import {
  BLACKLIST_REQUEST,
  BLACKLIST_SUCCESS,
  BLACKLIST_FAILED,
  REMOVE_FROM_BLACKLIST_REQUEST,
  REMOVE_FROM_BLACKLIST_ERROR,
  REMOVE_FROM_BLACKLIST_SUCCESS
} from '../../action/blackList/blackListConstants';

const initialState = {
  success: false,
  isLoading: false,
  hasError: false,
  blackListDomainData: null
};

export const blackList = (state = initialState, action) => {
  const { type, blackListData } = action;
  switch (type) {
    case BLACKLIST_REQUEST:
      return {
        ...state,
        hasError: false,
        isLoading: true
      };
    case BLACKLIST_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        success: true,
        blackListDomainData: blackListData
      };
    case BLACKLIST_FAILED:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        success: false
      };
    case REMOVE_FROM_BLACKLIST_REQUEST:
      return {
        ...state,
        hasError: false,
        isLoading: true
      };
    case REMOVE_FROM_BLACKLIST_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        success: true
      };
    case REMOVE_FROM_BLACKLIST_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        success: false
      };
    default:
      return state;
  }
};
